import React from "react";
import PropTypes from "prop-types";
import store from "../../../../state/store";
import helpers from "../../../../common/utils/utils";

const Controls = (props) => {
  const { userFlag, saveEntry, buttonDisabled } = props;

  const handleClick = (deletion) => {
    saveEntry(deletion);
  };

  return (
    <div className="varsome-modal-controls varsome-clearfix tw-pt-4 tw-border tw-border-solid">
      {userFlag && (
        <button
          type="button"
          className="btn btn-danger varsome-left"
          onClick={() => handleClick(true)}
        >
          Remove this classification
        </button>
      )}
      <button
        type="button"
        className="btn btn-success varsome-right"
        onClick={() => handleClick(false)}
        disabled={buttonDisabled}
      >
        Finish{" "}
        <i className="varsome-icons icon-chevron-right tw-ml-2 tw-text-xs" />
      </button>
      <div
        className="varsome-right varsome-text-muted tw-mr-4 tw-overflow-hidden"
        style={{
          paddingTop: "0.3rem",
        }}
      >
        Your contribution will be displayed using your real name:{" "}
        {store.getState().userName}{" "}
        {store.getState().userOrganisation &&
          store.getState().userOrganisationPublic &&
          `${helpers.truncate(`[${store.getState().userOrganisation}`, 35)}]`}
      </div>
    </div>
  );
};

Controls.propTypes = {
  saveEntry: PropTypes.func.isRequired,
  buttonDisabled: PropTypes.bool,
  userFlag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ]),
};

Controls.defaultProps = {
  buttonDisabled: false,
  userFlag: null,
};

export default Controls;
